export default __webpack_public_path__ + "static/media/Last.55b3922f.jpg";